/**
 * A date-only value, read as the calendar day it names.
 *
 * Date-only fields are stored at UTC midnight and shown in UTC, so every
 * viewer sees the same day. An ISO string or a Date already carries that
 * instant. A day written as text without a time — "Jan 12, 2027", which an
 * app's row mapper used to hand the table — does not: `new Date()` reads it
 * as LOCAL midnight, which east of UTC is the previous day in UTC, and the
 * table showed 11 Jan for 12 Jan (QA B02-01, staging 2026-10-26).
 *
 * Returns a Date, or null when the value is not a date.
 */
const ISO_DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const HAS_TIME = /T\d|\d:\d/;

export function calendarDate(v) {
  if (v == null || v === '') return null;
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return null;
  // "2027-01-12" is already read as UTC; an instant keeps its own time.
  if (typeof v !== 'string' || ISO_DATE_ONLY.test(v.trim()) || HAS_TIME.test(v)) return d;
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
}
